import { t } from "@lingui/macro";
import * as React from "react";
import { G, Path, Defs, ClipPath } from "react-native-svg";

import { Icon, IconProps } from "../../../primitive";

export const DiningIcon = (props: IconProps) => {
  const clipPathId = React.useId();

  return (
    <Icon
      fill="none"
      viewBox="0 0 16 16"
      color="#001A19"
      title={t`Dining`}
      {...props}
    >
      <G clipPath={`url(#${clipPathId})`}>
        <Path
          fill="currentColor"
          d="m7.566 9.907-4.488 5.475a1.745 1.745 0 1 1-2.46-2.46l5.475-4.488c.527-.445.77-1.142.634-1.819l-.205-1.027a1.897 1.897 0 0 1 .789-1.937L12.373.187a.4.4 0 0 1 .509.048l.128.128a.4.4 0 0 1-.024.588L9.199 4.156a.4.4 0 0 0-.1.484l.282.564a.4.4 0 0 0 .64.104l3.684-3.684a.4.4 0 0 1 .566 0l.105.105a.4.4 0 0 1 0 .566l-3.684 3.683a.4.4 0 0 0 .104.641l.564.282a.4.4 0 0 0 .484-.1l3.205-3.787a.4.4 0 0 1 .588-.024l.128.128a.4.4 0 0 1 .047.509L12.35 8.689a1.897 1.897 0 0 1-1.937.789l-1.027-.205a1.896 1.896 0 0 0-1.82.634Z"
        />
      </G>
      <Defs>
        <ClipPath id={clipPathId}>
          <Path fill="#fff" d="M0 0h16v16H0z" />
        </ClipPath>
      </Defs>
    </Icon>
  );
};
